import { useState } from "react"
import { assignWithBustedCache } from "shared/lib/utils"
import parse from "html-react-parser"
import styles from "./switch_your_plan.module.scss"

import { updateSubscriptionPlan } from "app/components/upgrade_plan_modal/pro_upgrade/api"

import iftttLogo from "images/logo-ifttt.svg?raw"
import arrowDownIcon from "images/icons/icon-arrow-down.svg?raw"
import { planNameBadge } from "shared/utils/tiers"

interface Props {
  declineLabel: string
  exploreUrl: string
  onDecline: func
  productId: string
  tierName: string
  trackCancelAction: (action: string, extraTags?: { [key: string]: string }) => void
  trackMutationError: func
}

const SwitchYourPlan = ({
  declineLabel,
  exploreUrl,
  onDecline,
  productId,
  tierName,
  trackCancelAction,
  trackMutationError,
}: Props) => {
  const targetPlanName = tierName === "Pro+" ? "Pro" : "Pro+"
  const [loading, updateLoading] = useState(false)

  const currentBadge = iftttLogo + planNameBadge(tierName)
  const targetBadge = iftttLogo + planNameBadge(targetPlanName)

  const handleSwithPlan = async () => {
    updateLoading(true)
    const result = await updateSubscriptionPlan({
      productId,
    })
    if (!result.errors?.length) {
      trackCancelAction("click_switch_plan", { target_plan: targetPlanName })
      let message
      if (targetPlanName === "Pro+") {
        message = "Successfully switched from Pro to Pro+!"
      } else {
        message = "Successfully switched from Pro+ to Pro!"
      }

      window.appendFlash(message, "success", () => {
        assignWithBustedCache(exploreUrl)
      })
    } else {
      trackMutationError(
        "updateSubscriptionPlan",
        result.errors,
        "There was a problem switching your account. Please contact support for more information.",
        updateLoading,
      )
    }
  }

  return (
    <div className={styles.switch_your_plan}>
      <h1 className="mb2--phone mb2--small-phone">Switch your plan</h1>

      <p className={styles.description}>
        Change to the right plan for you and access tools that help every thing work better together.
      </p>

      <div className={styles["plan-switch-illustration"]}>
        <div className={styles["plan-badge-current"]}>{parse(currentBadge)}</div>
        <div className={styles["plan-arrow"]}>{parse(arrowDownIcon)}</div>
        <div className={styles["plan-badge-target"]}>{parse(targetBadge)}</div>
      </div>

      <div className={styles.ctas}>
        <button type="button" className="button-secondary" onClick={handleSwithPlan} disabled={loading}>
          Switch to {targetPlanName}
        </button>
        <button
          type="button"
          className="button-secondary button-outlined"
          onClick={() => onDecline(updateLoading)}
          disabled={loading}
        >
          {declineLabel}
        </button>
      </div>
    </div>
  )
}

export default SwitchYourPlan
